import React from "react";
import PropTypes from "prop-types";
import css from "./top-bar.module.css";
export const TopBar = React.forwardRef(({ children }, ref) => {
  return /* @__PURE__ */ React.createElement("header", { className: css.topBar, ref }, children);
});
TopBar.displayName = "TopBar";
TopBar.propTypes = {
  children: PropTypes.node
};
